// @flow
import {
  BLOG_ARTICLES_ERROR,
  BLOG_ARTICLES_REQUEST,
  BLOG_ARTICLES_RESET,
  BLOG_CATEGORIES_REQUEST,
  BLOG_ARTICLES_REQUESTED,
  BLOG_CATEGORIES_REQUESTED,
  BLOG_ARTICLE_REQUEST,
  BLOG_ARTICLE_REQUESTED,
  BLOG_TESTIMONIALS_REQUEST,
  BLOG_TESTIMONIALS_REQUESTED
} from './constants';

import type { State, Action } from '../types';
import { connectIncludedData, connectIncludedDataSingleArticle } from './utils';

const initialState: State = {
  requesting: false,
  data: undefined,
  categories: undefined,
  singleArticleData: undefined,
  testimonialData: undefined,
  noOfPages: 1
};

export default (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case BLOG_CATEGORIES_REQUEST:
      return { ...state, requesting: true };
    case BLOG_ARTICLE_REQUEST:
      return { ...state, requesting: true };
    case BLOG_ARTICLE_REQUESTED:
      return {
        ...state,
        requesting: false,
        singleArticleData: connectIncludedDataSingleArticle(
          action.dataArticle,
          action.included || []
        )
      };
    case BLOG_ARTICLES_REQUEST:
      return { ...state, requesting: true };
    case BLOG_TESTIMONIALS_REQUEST:
      return { ...state, requesting: true };
    case BLOG_TESTIMONIALS_REQUESTED:
      return {
        ...state,
        requesting: false,
        testimonialData: connectIncludedData(action.dataTestimonials || [], action.included || [])
      };
    case BLOG_ARTICLES_REQUESTED:
      return {
        ...state,
        requesting: false,
        data: connectIncludedData(action.dataArticles || [], action.included || []),
        noOfPages: parseInt(action?.headers?.total_pages, 10)
      };
    case BLOG_CATEGORIES_REQUESTED:
      return {
        ...state,
        requesting: false,
        categories: action.dataCategories
      };
    case BLOG_ARTICLES_ERROR:
      return { ...state, requesting: false };
    case BLOG_ARTICLES_RESET:
      return initialState;
    default:
      return state;
  }
};
